/* Место для части прототипа, которая ещё не переписана и сама управляет своей разметкой (блок ссылки BotCore.ref, общие листы).
   Обёртка .lx не участвует в раскладке (display: contents). Разметка берётся один раз при появлении: дальше её меняет сам прототип,
   а React её не перерисовывает. */
import { memo, useState } from 'react';

export const LegacyHtml = memo(function LegacyHtml({ html }: { html: () => string }) {
  const [h] = useState(html);
  return <div className="lx" dangerouslySetInnerHTML={{ __html: h }} />;
});
